import { apiUrl, returnHtmlError } from "../utilities/Helpers";
import AppBanner from "../components/Footer/AppBanner";
import MatchInfo from "../components/Pages/MatchInfo";
import BlueHero from "../components/Pages/BlueHero";
import Image from "next/image";
import { useAppContext } from "../_context";
import Col from "react-bootstrap/Col";
import Head from "next/head";
import { getWebRoutes } from "../constants/routesHelper";

const Match = ({ errorCode, match }) => {
  if (errorCode) {
    return returnHtmlError(errorCode);
  }

  const [{ tx }] = useAppContext();

  return (
    <>
      <Head>
        <title>RacketPal - {match.name}</title>
      </Head>
      <BlueHero className="matches-hero" fixedBackdrop={true}>
        <div className="matches-hero-image position-absolute">
          <Image
            src={`/img/sport-bg/${match.sport}.jpg`}
            layout="fill"
            objectFit="cover"
            objectPosition="right"
            unoptimized={true}
          />
        </div>
        <div className="matches-hero-info text-white position-absolute px-2">
          <Col md={10} className="m-auto">
            <p className="mb-2">
              {tx[match.timeSlot.day] || match.timeSlot.day} •{" "}
              {tx[match.timeSlot.time] || match.timeSlot.time}
            </p>
            <h1 className="text-white mb-0">{match.name}</h1>
          </Col>
        </div>
      </BlueHero>
      <MatchInfo match={match} />
      <AppBanner />
    </>
  );
};

export const getServerSideProps = async (context) => {
  if (!context?.query?.id) {
    return {
      redirect: {
        permanent: false,
        destination: `/${getWebRoutes.mobileRoute}?from=${getWebRoutes.matches}`,
      },
      props: {},
    };
  }

  const result = await fetch(
    apiUrl(`/api/v1/web/match/${context?.query?.id}`),
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-api-version": "New",
      },
    },
  );
  const errorCode = result.ok ? false : 404; // ideally use result.status, but this doesn't always return something useful
  const match = await result.json();

  return {
    props: {
      errorCode,
      match,
      title: !errorCode && match ? match.name : null,
    },
  };
};

export default Match;
